export default __webpack_public_path__ + "static/media/2Do.3ebbf0bf.png";